export const DOMAIN_REGEX =
  /^(?!www\.|ww\d+\.)[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/

export const validateDomainAllowlist = value => {
  if (!value) return undefined
  const invalid = value
    .split(',')
    .map(d => d.trim())
    .filter(Boolean)
    .find(d => !DOMAIN_REGEX.test(d))
  return invalid ? `"${invalid}" is not a valid domain` : undefined
}

export const parseDomainAllowlistInput = value =>
  value
    ? value
        .split(',')
        .map(d => d.trim())
        .filter(Boolean)
    : []
